import React, { useState, useEffect, useCallback, useRef } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import Header from "../../components/Header";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import SuccessNotification from "../../components/Notifications/SuccessNotification";
import ErrorNotification from "../../components/Notifications/ErrorNotification";
import LoginNotification from "../../components/Notifications/LoginNotification";
import StatusWhatsApp from "../../components/Notifications/StatusWhatsApp";
import {
    faEdit,
    faEye,
    faSearch,
    faCircleCheck,
    faCircleXmark,
    faEllipsisH,
    faCircleArrowLeft,
} from "@fortawesome/free-solid-svg-icons";
import { faWhatsapp } from '@fortawesome/free-brands-svg-icons';
import Table from "../../components/Table";
import Section from "../../components/Section";
import SlideModal from "../../components/SlideModal";
import apiClient from "../../axios";
import { Tooltip } from "react-tooltip";
import useEscapeKey from "../../hooks/useEscapeKey";
import Loader from "../../components/Loader";

const WhatsAppDetailsList = ({ handleLogout }) => {
    const role = localStorage.getItem('role');
    const location = useLocation();
    const { contract } = location.state || {};
    const [data, setData] = useState([]);
    const [searchInput, setSearchInput] = useState("");
    const [searchTerm, setSearchTerm] = useState("");
    const [loading, setLoading] = useState(true);
    const [currentPage, setCurrentPage] = useState(1);
    const [totalItems, setTotalItems] = useState(0);
    const [selectedItem, setSelectedItem] = useState(null);
    const itemsPerPage = 10;
    const [isSuccessVisible, setIsSuccessVisible] = useState(false);
    const [isErrorVisible, setIsErrorVisible] = useState(false);
    const [isInfoVisible, setIsInfoVisible] = useState(false);
    const navigate = useNavigate();
    const [isModalOpen, setIsModalOpen] = useState(false);
    const [selectedStatsuItem, setSelectedStatusItem] = useState(null);
    const [openDropdown, setOpenDropdown] = useState(null);
    const dropdownRef = useRef(null);
    const [modalVisible, setModalVisible] = useState(false);

    useEffect(() => {
        const handleClickOutside = (event) => {
            const isClickInsideDropdown = dropdownRef.current?.contains(event.target);
            const isDropdownItem = event.target.closest(".dm-class");

            if (!isClickInsideDropdown && !isDropdownItem) {
                setOpenDropdown(false);
            }
        };
        document.addEventListener("mousedown", handleClickOutside);
        return () => {
            document.removeEventListener("mousedown", handleClickOutside);
        };
    }, []);

    useEscapeKey(() => setIsModalOpen(false));

    const toggleModal = async (item) => {
        if (!isModalOpen) {
            try {
                const response = await apiClient.get(`/whatsappDetails/detail/${item.id}`);
                const staff = {
                    general: item,
                    alternative: response.data,
                };
                setSelectedItem(staff);
                setIsModalOpen(true);
            } catch (error) {
                setIsErrorVisible(true);
                if (error.response && error.response.status === 401) {
                    setIsInfoVisible(true);
                }
            } finally {
                setIsSuccessVisible(true);
            }
        } else {
            setIsModalOpen(false);
        }
    };
    const handleStatusClick = (item) => {
        setSelectedStatusItem(item);
        setModalVisible(true);
    };

    const fetchAllData = useCallback(async (page = 1) => {
        try {
            setLoading(true);
            const response = await apiClient.get(`/whatsappDetails?search=${contract}&page=${page}`);
            if (Array.isArray(response.data.results)) {
                setData(response.data.results);
                setTotalItems(response.data.total);
            } else {
                setData([response.data.results]);
                setTotalItems(1);
            }
        } catch (error) {
            setIsErrorVisible(true);
            if (error.response && error.response.status === 401) {
                setIsInfoVisible(true);
            }
        } finally {
            setIsSuccessVisible(true);
            setLoading(false);
        }
    }, [contract])

    const handleSearch = useCallback(
        async (page = 1) => {
            try {
                // Construir la URL con los query params
                const params = new URLSearchParams();
                if (searchTerm) params.append("search", searchTerm);

                const response = await apiClient.get(
                    `/whatsappDetails?${params.toString()}&page=${page}`
                );

                if (Array.isArray(response.data.results)) {
                    setData(response.data.results); // Si es un array, lo dejamos tal cual
                } else {
                    setData([response.data.results]); // Si es un objeto, lo encapsulamos en un array
                }
                setTotalItems(response.data.total);
            } catch (error) {
                if (error.response && error.response.status === 401) {
                    setIsInfoVisible(true);
                }
            }
        },
        [searchTerm]
    );
    const handleFresh = async (code) => {
        //handleSearch(1);
        setCurrentPage(1);
        setSearchTerm(searchInput.trim());
    };

    const onRefreshThis = () => {
        setSearchTerm('');
        fetchAllData(1);
    };

    useEffect(() => {
        if (searchTerm) {
            handleSearch(currentPage);
        } else {
            fetchAllData(currentPage);
        }

    }, [fetchAllData, handleSearch, searchTerm, currentPage]);


    const handleCloseModal = () => {
        setModalVisible(false);
        setSelectedItem(null);
        onRefreshThis()
    };


    const handleClick = () => {
        navigate(-1);
    };

    const columns = [
        { title: "Id", key: "id" },
        { title: "RUC", key: "ruc" },
        { title: "Usuario", key: "user" },
        { title: "Plan", key: "plan" },
        { title: "NRO. Celular", key: "phone" },
        { title: "Fecha Caducidad", key: "dateExp" },
        { title: "Estado", key: "status" },
        { title: "Acciones", key: "acciones" },
    ];

    const renderRow = (item, index) => {
        const fechaFin = new Date(item.fechaFin);
        const hoy = new Date();
        const diffTime = fechaFin - hoy;
        const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
        return (
            <>
                <td>{item.id}</td>
                <td>{item.ruc}</td>
                <td>{item.userName}</td>
                <td>{item.moduleDescription}</td>
                <td>+{item.phoneNumber}</td>
                <td>{new Date(item.fechaFin).toLocaleString()}</td>
                <td>
                    {item.flagActive ? (
                        <button
                            className="status_button"
                            onClick={() => handleStatusClick(item)}
                        >
                            <FontAwesomeIcon
                                icon={faCircleCheck}
                                style={{ color: "green", fontSize: "24px" }}
                            />
                        </button>
                    ) : (
                        <button
                            className="status_button"
                            onClick={() => handleStatusClick(item)}
                        >
                            <FontAwesomeIcon
                                className="status_icon"
                                icon={faCircleXmark}
                                style={{ color: "red", fontSize: "24px" }}
                            />
                        </button>
                    )}
                </td>
                <td>
                    <div className="button-container">
                        <div className="desktop-buttons">
                            <Tooltip id="edit-tooltip" className="custom-tooltip" />
                            <button
                                data-tooltip-id="edit-tooltip"
                                className="icon-button edit-button"
                                data-tooltip-content="Editar"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    navigate(`/WhatsAppForm/${item.id}`, { state: { contract: item.numCont } });
                                }}
                            >
                                <FontAwesomeIcon icon={faEdit} />
                            </button>

                            <Tooltip id="contract-tooltip" className="custom-tooltip" />
                            <button
                                className="icon-button company-button"
                                onClick={() => toggleModal(item)}
                                data-tooltip-id="contract-tooltip"
                                data-tooltip-content="Detalle"
                            >
                                <FontAwesomeIcon icon={faEye} />
                            </button>
                            <Tooltip id="whatsapp-tooltip" className="custom-tooltip" />
                            {diffDays > 15 && item.flagActive ? (
                                <FontAwesomeIcon
                                    icon={faWhatsapp}
                                    style={{ color: 'green', fontSize: '33px' }}
                                    data-tooltip-id="whatsapp-tooltip"
                                    data-tooltip-content="Activo"
                                />
                            ) : diffDays <= 0  || !item.flagActive ?  (
                                <FontAwesomeIcon
                                    icon={faWhatsapp}
                                    style={{ color: 'red', fontSize: '33px' }}
                                    data-tooltip-id="whatsapp-tooltip"
                                    data-tooltip-content="Caducado"
                                />
                            ) : (
                                <FontAwesomeIcon
                                    icon={faWhatsapp}
                                    style={{ color: 'orange', fontSize: '33px' }}
                                    data-tooltip-id="whatsapp-tooltip"
                                    data-tooltip-content="Próximo a Caducar"
                                />
                            )}

                        </div>

                        <div className="mobile-dropdown">
                            <div className="dropdown-container-contract">
                                <button
                                    className="icon-button dropdown-button-contract"
                                    onClick={(e) => {
                                        e.stopPropagation();
                                        setOpenDropdown(
                                            openDropdown === item.id ? null : item.id
                                        );
                                    }}
                                >
                                    <FontAwesomeIcon icon={faEllipsisH} />
                                </button>
                                {openDropdown === item.id && (
                                    <div className="dropdown-menu-contract dm-class">
                                        <button
                                            className="dropdown-item-contract"
                                            onClick={(e) => {
                                                e.stopPropagation();
                                                navigate(`/WhatsAppForm/${item.id}`, { state: { contract: item.numCont } });
                                            }}
                                        >
                                            Editar
                                        </button>
                                        <button
                                            className="dropdown-item-contract"
                                            onClick={() => toggleModal(item)}
                                        >
                                            Detalle
                                        </button>
                                    </div>
                                )}
                            </div>
                        </div>
                    </div>
                </td>
            </>
        );
    };

    return (
        <div className="home-container">
            <Header onLogout={handleLogout} title="Planes de Whatsapp" />
            <div className="home-content">
                <Section>
                    <div className="button-return-container">
                        <div className="contener-return">
                            <FontAwesomeIcon
                                className="basic-shortcut-icon"
                                style={{ cursor: "pointer" }}
                                icon={faCircleArrowLeft}
                                onClick={handleClick}
                            />
                        </div>
                        <div className="filter-form">
                            <div className="basic-info-form-group">
                                <input
                                    type="text"
                                    id="customer"
                                    value={searchInput}
                                    onChange={(e) => setSearchInput(e.target.value)}
                                    placeholder="Plan de WhatsApp"
                                    onKeyDown={(e) => {
                                        if (e.key === "Enter") {
                                            handleFresh();
                                        }
                                    }}
                                />
                            </div>
                            <button className="basic-custom-button" onClick={handleFresh}>
                                <FontAwesomeIcon
                                    icon={faSearch}
                                    className="basic-shortcut-icon"
                                />
                                Buscar
                            </button>
                        </div>
                    </div>
                    {(role === 'SUPER_ADMIN' || role === 'ADMIN') && (
                        <div className="button-add">
                            <button
                                className="basic-custom-button"
                                onClick={(e) => {
                                    e.stopPropagation();
                                    navigate("/WhatsAppForm", { state: { contract: contract } });
                                }}
                            >
                                <FontAwesomeIcon
                                    className="basic-shortcut-icon"
                                    icon={faWhatsapp}
                                />
                                Crear Nuevo Plan de WhatsApp
                            </button>
                        </div>
                    )}
                </Section>
                <Table
                    title={`Lista de Planes de WhatsApp del Contrato nro. (${contract})`}
                    rows={data}
                    columns={columns}
                    icon={faWhatsapp}
                    renderRow={renderRow}
                    currentPage={currentPage}
                    totalItems={totalItems}
                    itemsPerPage={itemsPerPage}
                    onPageChange={setCurrentPage}
                    onRefresh={onRefreshThis}
                    loading={loading}
                    flagPagination={true}
                />
                {loading && <Loader />}
                <SuccessNotification
                    message={"Se ha cargado correctamente"}
                    isVisible={isSuccessVisible}
                    onClose={() => setIsSuccessVisible(false)}
                />
                <ErrorNotification
                    message="Ups! Ocurrio un Problema"
                    isVisible={isErrorVisible}
                    onClose={() => setIsErrorVisible(false)}
                />
                <LoginNotification
                    message="Vuele a iniciar sesión"
                    isVisible={isInfoVisible}
                    onClose={() => setIsInfoVisible(false)}
                    onLogout={handleLogout}
                />
                {selectedStatsuItem && (
                    <StatusWhatsApp
                        detail={selectedStatsuItem}
                        message={
                            selectedStatsuItem.flagActive
                                ? "Plan de WhatsApp Activo. ¿Desea Inactivarlo?"
                                : "Plan de WhatsApp Inactivo. ¿Desea Activarlo?"
                        }
                        isVisible={modalVisible}
                        onClose={handleCloseModal}
                        origen ='whatsApp'
                    />
                )}
                <SlideModal
                    isOpen={isModalOpen}
                    onClose={toggleModal}
                    title="Detalles del Plan de WhatsApp"
                >
                    <div className="section-container-form">
                        <h4 className="section-title-form">ID</h4>
                        <hr className="section-divider-form" />
                        <div className="form-group-form">
                            <label>{selectedItem?.general.id}</label>
                        </div>

                        <h4 className="section-title-form">RUC</h4>
                        <hr className="section-divider-form" />
                        <div className="form-group-form">
                            <label>{selectedItem?.general.ruc}</label>
                        </div>

                        <h4 className="section-title-form">NOMBRE</h4>
                        <hr className="section-divider-form" />
                        <div className="form-group-form">
                            <label>{selectedItem?.general.name + " " + selectedItem?.general.lastName}</label>
                        </div>

                        <h4 className="section-title-form">NÚMERO DE CELULAR</h4>
                        <hr className="section-divider-form" />
                        <div className="form-group-form">
                            <label>{"+" + selectedItem?.general.phoneNumber}</label>
                        </div>

                        <h4 className="section-title-form">PLAN</h4>
                        <hr className="section-divider-form" />
                        <div className="form-group-form">
                            <label>{selectedItem?.general.moduleDescription}</label>
                        </div>

                        <h4 className="section-title-form">USUARIO</h4>
                        <hr className="section-divider-form" />
                        <div className="form-group-form">
                            <label>{selectedItem?.general.userName}</label>
                        </div>

                        <h4 className="section-title-form">EMAIL</h4>
                        <hr className="section-divider-form" />
                        <div className="form-group-form">
                            <label>{selectedItem?.alternative.email}</label>
                        </div>

                        <h4 className="section-title-form">ESTADO</h4>
                        <hr className="section-divider-form" />
                        <div className="form-group-form">
                            <label>
                                {selectedItem?.general.flagActive === 1 ? "Activo" : "Inactivo"}
                            </label>
                        </div>

                    </div>
                </SlideModal>
            </div>
        </div>
    );
};

export default WhatsAppDetailsList;
